import React from 'react';

function IconCreditCard() {
  return (
    <>
      <svg fill="#000000" viewBox="0 0 24 24" id="credit-card-2" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <rect id="primary" x="2" y="4" width="20" height="16" rx="2" fill="#ddd"></rect>
          <path
            id="secondary"
            d="M22,10H2V8H22Zm-4,5H14a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z"
            fill="#000"
          ></path>
        </g>
      </svg>
    </>
  );
}

export default IconCreditCard;
